/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default [
    {
        path: '/news',
        name: 'News',
        component: () => import('@/views/News/NewsList.vue'),
        meta: { permission: 'news.view' }
    },
    {
        path: '/news/new',
        name: 'NewsCreate',
        component: () => import('@/views/News/NewsCreate.vue'),
        meta: { permission: 'news.create' }
    },
    {
        path: '/news/categories',
        name: 'NewsCategories',
        component: () => import('@/views/News/NewsCategories.vue'),
        meta: { permission: 'news-categories.view' }
    },
    {
        path: '/news/:id',
        name: 'NewsView',
        component: () => import('@/views/News/NewsView.vue'),
        meta: { permission: 'news.view' }
    },
    {
        path: '/news/:id/edit',
        name: 'NewsEdit',
        component: () => import('@/views/News/NewsEdit.vue'),
        meta: { permission: 'news.update' }
    },
]
